import { Capacitor } from '@capacitor/core'
import axios from 'axios'
import { useCallback } from 'react'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'
import { environment } from '@/config/environment'

function useCheckVersion() {
  // Methods
  // ------------------------------------------------------------------------- /
  const checkVersion = useCallback((version: string) => {
    const platform = Capacitor.getPlatform()

    return axios.get<boolean>(`${environment.api}/version/check-version`, {
      params: {
        version,
        platform: platform === 'ios' || platform === 'android' ? platform : undefined,
      },
      headers: {
        'Cache-Control': 'no-cache',
      },
    })
  }, [])

  return {
    checkVersion: useAxiosAsync(checkVersion),
  }
}

export { useCheckVersion }
